// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetEventByEventIdentifierRequestModel from '../../model/get-event-by-event-identifier-request-model';
import GetEventByEventIdentifierRequestDTO from '../dto/get-event-by-event-identifier-request-dto';
import dtoSchema from '../schemas/get-event-by-event-identifier-request-schema';

export default abstract class GetEventByEventIdentifierRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetEventByEventIdentifierRequestDTO>) {
    super();
    if (data) {
      this.eventIdentifier = data.eventIdentifier;
    }
  }
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;

  static toModel(dto: DeepPartial<GetEventByEventIdentifierRequestDTO>): GetEventByEventIdentifierRequestModel;
  static toModel(dto: DeepPartial<GetEventByEventIdentifierRequestDTO> | undefined | null): GetEventByEventIdentifierRequestModel | undefined;
  static toModel(dto: DeepPartial<GetEventByEventIdentifierRequestDTO> | undefined | null): GetEventByEventIdentifierRequestModel | undefined {
    return dto ? new GetEventByEventIdentifierRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetEventByEventIdentifierRequestModel> | GetEventByEventIdentifierRequestModel): GetEventByEventIdentifierRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      eventIdentifier: unwrapped.eventIdentifier,
    } as GetEventByEventIdentifierRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetEventByEventIdentifierRequestModel, can not map to GetEventByEventIdentifierRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
